import { Routes } from '@angular/router';
import { SingleSiteAnalysisComponent } from './single-site-analysis.component';
import { SingleSiteAnalysisImportPopupComponent } from './single-site-analysis-import.component';

export const SINGLE_SITE_ANALYSIS_ROUTES: Routes = [
    {
        path: 'single-site-analysis',
        component: SingleSiteAnalysisComponent,
        data: { pageTitle: 'single-site-analysis.title' }
    },
    {
        path: 'single-site-analysis-import',
        component: SingleSiteAnalysisImportPopupComponent,
        outlet: 'popup'
    },
];
